import {
    call,
    put,
    select,
    takeLatest,
    takeEvery,
    all,
    delay
  } from 'redux-saga/effects';
import * as constants from './constants';
import api from '../../util/api';
import helper from '../../util/helper';
// import * as RootNavigation from '../../../RootNavigation';
import makeSelectNotificationDetailScreen from './selector';
import { getNotificationsFail, getNotificationsSuccess } from './actions';
  
  export function* doGetNotifications(action) {
    const {id_akun} = action;
    const dataset = yield select(makeSelectNotificationDetailScreen());
    try {
      const response = yield call(api.user.getPrivileges, id_akun);
      const {success} = response.data;
  
      yield put(
        getNotificationsSuccess(success),
      );
      
      // RootNavigation.navigate('page', {screen: 'home'});

    } catch (err) {
      console.log(err);
      helper.errorToast("Terjadi kegagalan proses ambil data pastikan koneksi internet anda normal atau segera hubungi admin");
      yield put(getNotificationsFail(err));
    }
  }

  // Individual exports for testing
  export default function* notificationDetailScreenSaga() {
    yield all([
      takeLatest(constants.GET_NOTIFICATIONS, doGetNotifications),
    ]);
  }
  